import React from 'react';
import {HomePage , LoginPage , AccountPage, RegisterPage ,ConfirmEmailPage ,
     ResendEmailPage ,PnpPage , TncPage, WalletPage , HWGCashPage , ForgetPasswordPage , ResetPasswordPage  } from '../Views';
import { Router, Route , Switch , Redirect } from 'react-router-dom';
import {loadingActions,alertActions} from '../_actions';
import { connect } from 'react-redux';
import { history } from '../_helpers';
import { PrivateRoute , WrapperHoc ,MemberLayoutHoc } from '../_components';
import LoadingBar from 'react-redux-loading-bar';
import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/flip.css';

class App extends React.Component
{
    componentDidMount(){

        //get error from sessionstorage 
        var alert_msg = sessionStorage.getItem('alert'); 
        var type = sessionStorage.getItem('type');

        if(alert_msg){
            if(type === 'error'){
                Alert.error(alert_msg, {
                    position: 'bottom-right' , 
                    effect : 'flip'
                });
            }
            else {
                Alert.success(alert_msg, {
                    position: 'bottom-right' , 
                    effect : 'flip'
                });
            }
        }

        //clear
        sessionStorage.clear(); 
    }

    render(){ 
        return (
            <div>
                <LoadingBar style={{ backgroundColor: '#39b5df', zIndex:'99' }}/>
                <Alert timeout={5000} stack={{limit: 1}} />
                <Router history = {history} >
                    <div>
                        <Switch>
                            <Route exact path="/" component={ HWGCashPage } />
                            <Route path="/hwgcash" component={ HWGCashPage }/>
                            <PrivateRoute path="/account" component={ AccountPage } />
                            <WrapperHoc>
                                <Route path="/login" component={ LoginPage }/>
                                <Route path="/register" component={ RegisterPage }/>
                                <Route path="/confirmemail" component={ ConfirmEmailPage }/>
                                <Route path="/resendemail" component={ ResendEmailPage }/>
                                <Route path="/privacypolicy" component={ PnpPage }/>
                                <Route path="/tnc" component={ TncPage }/>
                                <Route path="/forgetpassword" component={ ForgetPasswordPage }/>
                                <Route path="/resetpassword" component={ ResetPasswordPage }/>
                            </WrapperHoc>
                            <Route path="*" component={ HomePage } />
                        </Switch>   
                    </div>
                </Router>
            </div>
        )
    }
}

function mapStateToProps(state) {
    const { alert } = state;
    return {
        alert 
    };
}

const connectedApp = connect(mapStateToProps)(App);
export { connectedApp as App }; 



// WEBPACK FOOTER //
// ./src/App/App.jsx